import { IconButton } from "@material-ui/core";
import { Star, StarBorder } from "@material-ui/icons";
import PropTypes from "prop-types";
import React from "react";
import { FoldersApi } from "../../api/folders/folders";
import * as StringConstant from "../../data/StringConstants";
import { useToggle } from "../../hooks/useToggle";
import yellow from "../../theme/colors/yellow";


export default function UserStar(props) {
	const { correlationId, isStarred, starContext, subContext, onClickCallback } = props;
	const [starred, setStarred] = useToggle(isStarred);
	const starIconStyle = { fill: yellow[400] };

	const toggleStar = async (event, starred) => {
		event.stopPropagation();

		try {
			setStarred(!starred);
			await FoldersApi.toggleItemStar(correlationId, starred, starContext, subContext);
			onClickCallback(!starred);
		} catch (err) {
			console.log(`${StringConstant.TOGGLE_STAR_ERR}: ${err}`);
		}
	};

	if (starred) {
		return (
			<IconButton
				aria-label="starred"
				onClick={event => toggleStar(event, starred)}
			>
				<Star style={starIconStyle} />
			</IconButton>
		);
	}

	return (
		<IconButton
			aria-label="unstarred"
			onClick={event => toggleStar(event, starred)}
		>
			<StarBorder style={starIconStyle} />
		</IconButton>
	);
}

UserStar.propTypes = {
	correlationId: PropTypes.string.isRequired,
	isStarred: PropTypes.bool.isRequired,
	starContext: PropTypes.number.isRequired,
	/* Optional callback used to return the new stage of the UserStar component after it has been clicked. */
	onClickCallback: PropTypes.func
};
